export default "__VITE_ASSET__D1dnnYQ2__"